/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Geometry } from './geometry';


/**
 * Geometric feature
 */
import { ValidateUtils } from 'app/shared/utils';

export class Feature { 
    /**
     * GeoJSON type (Feature)
     */
    type: Feature.TypeEnum;
    /**
     * Feature properties
     */
    properties?: object;
    geometry: Geometry;

    constructor(item?: Partial<Feature>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            type: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.type : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            properties: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.properties : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            geometry: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.geometry : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: Feature.isValid,
        };
    }

    static isValid(obj: Feature): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = Feature.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.type.isValid(item);
            result = result && validationObject.properties.isValid(item);
            result = result && validationObject.geometry.isValid(item);
            return result;
        } else {
            return false
        }
    }
}
export namespace Feature {
    export type TypeEnum = 'Feature';
    export const TypeEnum = {
        Feature: 'Feature' as TypeEnum
    };
}


